import React from 'react';
import { connect } from 'react-redux';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/styles/index.styl';

import Portfolio from '../src/scripts/containers/portfolio';

class PortfolioPage extends React.Component {
  static async getInitialProps({ req, store, isServer, query }) {
    const { operatorId } = query;
    return { operatorId };
  }

  componentDidMount() {
    document.documentElement.classList.remove('preload');
  }

  render() {
    const { operatorId } = this.props;
    return (
      <>
        <Portfolio operatorId={operatorId} iframe={true} isSalsa={false} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const event = state.activeEvent;
  return {
    pageType: 'portfolio',
  };
};

export default connect(mapStateToProps)(PortfolioPage);
